import { Droplet, Disc, CircleDot, ScanLine, Cog, GitBranch, Wind, ClipboardCheck, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/api";

const ICON_MAP = { Droplet, Disc, CircleDot, ScanLine, Cog, GitBranch, Wind, ClipboardCheck };

const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="bg-[#0a0a0a] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mb-16 max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-[2px] w-12 bg-[#e10600]" />
            <span className="font-['Exo_2'] uppercase text-xs tracking-[0.4em] text-[#e10600] font-bold">What we do</span>
          </div>
          <h2 className="font-['Anton'] text-white text-5xl md:text-6xl uppercase leading-none">
            Full-Service <br /><span className="text-[#e10600]">Auto Repair</span>
          </h2>
          <p className="font-['Exo_2'] text-gray-400 mt-6 text-lg max-w-2xl">
            From the basics to the complex — our certified team handles every system on your vehicle with precision and zero shortcuts.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#2e2e2e] border border-[#2e2e2e]">
          {SERVICES.map((s, idx) => {
            const Icon = ICON_MAP[s.icon] || Cog;
            return (
              <div key={s.key} data-testid={`service-card-${s.key.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
                className="group bg-[#141414] hover:bg-[#1a1a1a] p-8 lg:p-10 transition-all duration-200 cursor-default relative">
                <div className="absolute top-4 right-4 text-gray-700 group-hover:text-[#e10600] transition-colors">
                  <span className="font-['Anton'] text-2xl">0{idx + 1}</span>
                </div>
                <div className="w-14 h-14 bg-[#0a0a0a] border border-[#2e2e2e] group-hover:border-[#e10600] flex items-center justify-center mb-6 transition-colors">
                  <Icon className="w-6 h-6 text-[#e10600]" strokeWidth={1.5} />
                </div>
                <h3 className="font-['Anton'] text-white text-2xl uppercase mb-3 tracking-wide">{s.key}</h3>
                <p className="font-['Exo_2'] text-gray-400 text-sm leading-relaxed">{s.desc}</p>
                <div className="mt-6 flex items-center gap-2 text-[#e10600] opacity-0 group-hover:opacity-100 transition-opacity">
                  <a href="#booking" className="font-['Exo_2'] uppercase text-[10px] tracking-[0.3em] font-bold">Book Now</a>
                  <ArrowUpRight className="w-3 h-3" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
